import { SVGProps, Ref, forwardRef } from 'react';

export const FolderArrowRightOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 6.048v-.381C1 2.167 2.167 1 5.667 1h2L8.2 2.333h2.133c3.153 0 4.412.947 4.631 3.693.655.393.981 1.028 1.03 1.974H14.59c-.026-.355-.107-.537-.176-.627-.116-.153-.54-.473-2.211-.473H3.796c-1.671 0-2.095.32-2.21.473-.146.19-.342.779.02 2.534.348 1.69.768 2.525 1.26 2.978.45.417 1.188.715 2.734.715h2.9V15H5.6C2.204 15 .96 13.707.235 10.19-.22 7.98-.04 6.697 1 6.048m12.501-.474c-.113-.675-.309-1.027-.512-1.23-.314-.314-.983-.61-2.656-.61h-3.08L6.718 2.4H5.667c-1.673 0-2.342.297-2.656.61-.31.31-.602.963-.61 2.578A10 10 0 0 1 3.795 5.5h8.408q.723 0 1.297.074"
                    fill="currentColor"
                />
                <path
                    d="M16 12.256 13.255 9.51l-.99.99 1.052 1.052H9.192v1.4h4.131l-1.057 1.057.99.99z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
FolderArrowRightOutlinedSize16Glyph.displayName = 'FolderArrowRightOutlinedSize16Glyph';
